// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bidoof: PokeData = {
  "id": 399,
  "name": "bidoof",
  "height": 5,
  "weight": 200,
  "base_experience": 50,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "swords-dance",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "growl",
    "defense-curl",
    "amnesia",
    "rest",
    "hyper-fang",
    "super-fang",
    "curse",
    "rollout",
    "crunch",
    "taunt",
    "superpower",
    "yawn"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "growl",
    "curse",
    "crunch",
    "superpower",
    "scary-face",
    "body-slam",
    "tri-attack",
    "leer",
    "supersonic",
    "quick-attack"
  ],
  "evolution_chain": {
    "id": 207,
    "item": null,
    "species": [
      {
        "name": "bidoof",
        "order": 429,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bibarel",
        "order": 430,
        "types": [
          PokeType.NORMAL,
          PokeType.WATER
        ],
        "evolves_from_species_id": 399,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49.5,
    "speed": 31,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
